<template>
  <WdsStack
    direction-column
    class="tw-bg-true-gray-50 tw-rounded tw-pb-3 tw-border tw-border-gray-300"
    v-bind="$attrs"
  >
    <WdsStack class="tw-p-3" align-center gap-xs>
      <WdsHeading class="tw-text-lg" type="title3">{{ title }}</WdsHeading>
      <slot name="title-actions" />
    </WdsStack>
    <slot />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsHeading, WdsStack } from '@worksome/wds-components'

defineOptions({ inheritAttrs: false })

defineProps<{ title: string }>()
</script>
